const rodis = [

  // SBD (línea actual)
  {
    id: "sbd-classic",
    slug: "rodilleras-sbd",
    name: "Rodilleras SBD",
    brand: "SBD Clásicas",
    category: "rodilleras",
    sizes: ["2XS","XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
    bestSeller: true,
    sizeGuide: "/Guias/sg-rodis-sbd.png",
    variants: [
      { color: "Classic", images: ["/Productos/rodis-sbd.webp","/Productos/rodis-sbd-2.webp","/Productos/rodis-sbd-3.webp","/Productos/rodis-sbd-4.webp",], price: 185},
      { color: "2013", images: ["/Productos/rodis-sbd-2013.jpg","/Productos/rodis-sbd-2013-2.webp","/Productos/rodis-sbd-2013-3.webp"], price: 160 },
      { color: "Serenity", images: ["/Productos/sbd-ser.jpg","/Productos/sbd-ser-2.webp","/Productos/sbd-ser-3.webp",], price: 189},
      { color: "Resolve", images: ["/Productos/sbd-res.webp","/Productos/rodis-sbd-res-2.webp","/Productos/rodis-sbd-res-3.webp",], price: 189},
      { color: "Aspire", images: ["/Productos/rodis-sbd-asp.jpg","/Productos/rodis-sbd-asp-2.webp","/Productos/rodis-sbd-asp-3.jpg","/Productos/rodis-sbd-asp-4.jpg"], price: 189 },
      { color: "Reflect", images: ["/Productos/rodis-sbd-ref.webp","/Productos/rodis-asp-ref-2.webp","/Productos/rodis-sbd-ref-3.webp","/Productos/rodis-sbd-ref-4.webp",], price: 189 },
      { color: "Forge Grey", images: ["/Productos/rodis-sbd-for-grey.webp","/Productos/rodis-sbd-for-gre-2.webp","/Productos/rodis-sbd-for-gre-3.webp"], price: 189 },
      { color: "Forge Orange", images: ["/Productos/rodis-sbd-for-nar.webp","/Productos/rodis-sbd-for-nar-2.webp",], price: 189 },
      { color: "Nova", images: ["/Productos/rodis-sbd-nova.jpg","/Productos/rodis-sbd-nov-2.webp"], price: 189 },
    ],
  },

  // SBD 2013
/*   {
    id: "sbd-2013",
    category: "rodilleras",
    slug: "rodilleras-sbd-2013",
    name: "Rodilleras SBD 2013",
    brand: "SBD Clásicas",
    sizes: ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
    variants: [
      { color: "Classic", image: "/Productos/rodis-sbd-2013.webp", price: 160 },
    ],
  }, */

  // SBD Powerlifting
  {
    id: "sbd-power",
    slug: "rodilleras-sbd-powerlifting",
    name: "Rodilleras SBD Powerlifting",
    category: "rodilleras",
    sizeGuide: "/Guias/sg-rodis-sbd.png",
    brand: "SBD Powerlifting",
    sizes: ["2XS","XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"],
/*     sizeGuide: "/Productos/rodis-sbd-power.webp", */
    variants: [
      { color: "Classic", images: ["/Productos/rodis-sbd-power.webp","/Productos/sbd-power-2.webp","/Productos/sbd-power-3.webp","/Productos/sbd-power-4.webp"], price: 229 },
      { color: "Serenity", images: ["/Productos/sbd-power-ser.jpg","/Productos/sbd-power-ser-2.jpg","/Productos/sbd-power-ser-3.webp"], price: 235 },
      { color: "Resolve", images: ["/Productos/sbd-power-res.webp","/Productos/sbd-power-res-2.webp","/Productos/sbd-power-res-3.jpg","/Productos/sbd-power-res-4.webp",], price: 235 },
      { color: "Aspire", images: ["/Productos/rodis-sbd-power-asp.jpg","/Productos/sbd-power-asp-2.jpg","/Productos/sbd-power-asp-3.webp","/Productos/sbd-power-asp-4.webp","/Productos/sbd-power-asp-5.webp",], price: 235 },
      { color: "Forge Grey", images: ["/Productos/rodis-sbdpower-for-grey.webp","/Productos/sbd-power-for-2.webp","/Productos/sbd-power-for-3.webp",], price: 235 },
      { color: "Forge Orange", images: ["/Productos/rodis-sbdpower-for-nar.jpg","/Productos/sbd-power-for-nar-2.webp",], price: 235 },
      { color: "Nova", images: ["/Productos/rodis-sbd-power-nova.webp","/Productos/sbd-power-nov-2.webp","/Productos/sbd-power-nov-3.webp",], price: 235 }
    ],
  },

  // A7 Stiff
  {
    id: "a7-stiff",
    category: "rodilleras",
    slug: "rodilleras-a7-stiff",
    name: "Rodilleras A7 Stiff",
    brand: "A7",
    sizes: ["2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "6XL"],
    sizeGuide: "/Guias/sg-rodis-a7.png",
    variants: [
      { color: "Shadow Stone", images: ["/Productos/a7-st-sh.webp","/Productos/a7-stiff-shst-2.webp","/Productos/a7-stiff-shst-3.webp"], price: 177.5 },
      { color: "Stealth", images: ["/Productos/a7-st-sth.webp","/Productos/a7-stiff-sth-2.webp","/Productos/a7-stiff-sth-3.webp"], price: 177.5 },
      { color: "Dusk", images: ["/Productos/a7-stiff-dusk.webp","/Productos/a7-stiff-dusk-2.webp"], price: 177.5 },
      { color: "Red Dawn", images: ["/Productos/a7-st-red.webp","/Productos/a7-stiff-rd-2.webp"], price: 177.5 },
      { color: "Tides Blue", images: ["/Productos/a7-stiff-tides.webp","/Productos/a7-stiff-tides-2.jpg"], price: 177.5 },
      { color: "Polar", images: ["/Productos/a7-st-po.webp","/Productos/a7-stiff-pol-2.webp"], price: 177.5 },
      { color: "Ivory Rose", images: ["/Productos/a7-st-ivo.webp","/Productos/a7-stiff-ivo-2.webp"], price: 177.5 },
      { color: "Emerald", images: ["/Productos/a7-st-eme.webp","/Productos/a7-stiff-eme-2.webp"], price: 177.5 },
    ],
  },

  // Stoic
  {
    id: "stoic",
    category: "rodilleras",
    slug: "rodilleras-stoic",
    name: "Rodilleras Stoic",
    sizeGuide: "/Guias/sg-rodis-stoic.png",
    brand: "STOIC",
    sizes: ["3XS", "2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL"],
    variants: [
      { color: "Classic", image: "/Productos/rodis-stoic.webp", price: 152.5 },
      { color: "Stealth", image: "/Productos/stoic-sth.webp", price: 152.5 },
      { color: "Blue", image: "/Productos/stoic-blue.webp", price: 152.5 },
      { color: "Maroon", image: "/Productos/stoic-maroon.webp", price: 152.5 },
    ],
  },

];

export default rodis;
  